import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductCard from './components/ProductCard';
import TshirtModal from './components/TshirtModal';
import About from './components/About';
import CartPage from './components/CartPage';
import Footer from './components/Footer';
import { tshirts, hoodies } from './mock/data';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [productType, setProductType] = useState('tshirts');

  const handleCheckout = () => {
    const message = `¡Hola VELNO! Quiero comprar:\n\n${cartItems.map(item => 
      `- ${item.name} (Talla: ${item.size}, Color: ${item.color}) - $${item.price.toFixed(2)} USD x ${item.quantity}`
    ).join('\n')}\n\nTotal: $${cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0).toFixed(2)} USD (+precio de envío dependiendo la ciudad)`;
    
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/593990927080?text=${encodedMessage}`, '_blank');
    setCartItems([]);
    setCurrentPage('home');
  };

  const addToCart = (product) => {
    setCartItems(prevCart => {
      const existingItemIndex = prevCart.findIndex(item => 
        item.id === product.id && 
        item.color === product.color && 
        item.size === product.size &&
        item.type === product.type
      );
      
      if (existingItemIndex >= 0) {
        return prevCart.map((item, index) =>
          index === existingItemIndex
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1, type: productType }];
      }
    });
  };

  const removeFromCart = (itemToRemove) => {
    setCartItems(prevCart => prevCart.filter(item => 
      !(item.id === itemToRemove.id && 
        item.color === itemToRemove.color && 
        item.size === itemToRemove.size &&
        item.type === itemToRemove.type)
    ));
  };

  const updateCartQuantity = (itemId, color, size, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart({ id: itemId, color, size, type: productType });
      return;
    }
    setCartItems(prevCart => prevCart.map(item =>
      item.id === itemId && item.color === color && item.size === size
        ? { ...item, quantity: newQuantity }
        : item
    ));
  };

  const createSeparatedVariants = (products) => {
    const maxColors = Math.max(...products.map(p => p.colors.length));
    let displayVariants = [];
    
    for (let pos = 0; pos < maxColors; pos++) {
      products.forEach(product => {
        if (product.colors[pos]) {
          displayVariants.push({
            ...product,
            currentColorIndex: pos,
            currentColorName: product.colors[pos].name
          });
        }
      });
    }
    
    return displayVariants;
  };

  const renderPage = () => {
    switch(currentPage) {
      case 'tshirts':
        const tshirtVariants = createSeparatedVariants(tshirts);
        return (
          <div className="py-20 px-4 max-w-7xl mx-auto">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {tshirtVariants.map((variant, index) => (
                <ProductCard 
                  key={`${variant.id}-${variant.currentColorIndex}`}
                  tshirt={variant} 
                  selectedColorIndex={variant.currentColorIndex}
                  onSelect={(product, colorName) => { 
                    setSelectedProduct({ ...product, initialColor: colorName }); 
                    setProductType('tshirt'); 
                  }}
                />
              ))}
            </div>
            {selectedProduct && (
              <TshirtModal
                tshirt={selectedProduct}
                onAddToCart={addToCart}
                onClose={() => setSelectedProduct(null)}
                cartItems={cartItems}
                productType="tshirt"
              />
            )}
          </div>
        );
      case 'hoodies':
        const hoodieVariants = createSeparatedVariants(hoodies);
        return (
          <div className="py-20 px-4 max-w-7xl mx-auto">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {hoodieVariants.map((variant, index) => (
                <ProductCard 
                  key={`${variant.id}-${variant.currentColorIndex}`}
                  tshirt={variant}
                  selectedColorIndex={variant.currentColorIndex}
                  onSelect={(product, colorName) => { 
                    setSelectedProduct({ ...product, initialColor: colorName }); 
                    setProductType('hoodie'); 
                  }}
                />
              ))}
            </div>
            {selectedProduct && (
              <TshirtModal
                tshirt={selectedProduct}
                onAddToCart={addToCart}
                onClose={() => setSelectedProduct(null)}
                cartItems={cartItems}
                productType="hoodie"
              />
            )}
          </div>
        );
      case 'about':
        return <About />;
      case 'cart':
        return (
          <CartPage 
            cartItems={cartItems} 
            onCheckout={handleCheckout}
            onContinueShopping={() => setCurrentPage('tshirts')}
            onRemoveItem={removeFromCart}
            updateQuantity={updateCartQuantity}
          />
        );
      default:
        return <Hero />;
    }
  };

  return (
    <div className="font-sans flex flex-col min-h-screen">
      <Navbar 
        setCurrentPage={setCurrentPage} 
        cartItemCount={cartItems.reduce((sum, item) => sum + item.quantity, 0)}
      />
      <main className="flex-grow">
        {renderPage()}
      </main>
      <Footer />
    </div>
  );
};

export default App;